// src/scripts/firestore/venuesFs.js
import { db } from "@/firebase";
import { collection, getDocsFromServer, getDocs } from "firebase/firestore";

function s(v) {
  return String(v ?? "").trim();
}

function getDbDebug() {
  // These are safe to log
  const projectId = db?.app?.options?.projectId;
  const appName = db?.app?.name;

  // Firestore "databaseId" is not public API, but exists internally in v9
  // We log it if present so we can prove whether you're on "(default)" or another DB.
  const internalDbId = db?._databaseId?.database ?? db?._database?.database ?? null;

  return { projectId, appName, internalDbId };
}

/**
 * Returns ALL venue docs in /venues.
 * First tries SERVER (bypasses cache).
 * Falls back to normal getDocs() if server fails (offline etc).
 */
export async function fsListAllVenues() {
  const debug = getDbDebug();
  // console.log("[venuesFs] Firestore debug:", debug);

  const colRef = collection(db, "venues");

  let snap;
  try {
    // ✅ Force server read (this is the key)
    snap = await getDocsFromServer(colRef);
    // console.log("[venuesFs] read FROM SERVER ok. size=", snap.size, "fromCache=", snap.metadata?.fromCache);
  } catch (e) {
    console.warn("[venuesFs] getDocsFromServer FAILED, falling back to getDocs()", e?.message || e);
    snap = await getDocs(colRef);
    // console.log("[venuesFs] read FALLBACK. size=", snap.size, "fromCache=", snap.metadata?.fromCache);
  }

  const venues = snap.docs
    .map((d) => {
      const data = d.data() || {};
      const id = d.id;
      const label =
        s(data.venue_name) ||
        s(data.venueName) ||
        s(data.name) ||
        id;

      return { id, label };
    })
    .filter((x) => !!x.id)
    .sort((a, b) => a.label.localeCompare(b.label));

  // console.log("[venuesFs] ids:", venues.map((v) => v.id));
  return venues;
}